<template>
  <footer class="c-footer">
    <div class="container">
      <div class="footer mb-10">
        <div class="content-footer">
          <div class="mr-10 mb-10">
            <div class="mb-10 flex justify-content-between align-items-center">
              <img
                style="max-height: 25px;transform: translateX(-15px);"
                class="logo-wghn"
                :src="images.LogoWBooking"
                alt=""
              />

              <a
                href="http://online.gov.vn/Home/WebDetails/126552"
                target="_blank"
              >
                <img
                  style="max-height: 55px;"
                  class="logo-wghn"
                  src="@/assets/img/logo/logo-tick-xanh.png"
                  alt=""
                />
              </a>
            </div>
            <p class="c-bold-text title-footer m-0">{{ $t("wap.text98") }}:</p>
            <div class="mt-5 ml-20">
              <div>
                <p
                  style="line-height: 1.2;max-width:400px"
                  class="m-0 text-footer"
                >
                  {{ $t("certificate") }}
                </p>
                <p style="line-height: 1.2;" class="m-0 text-footer">
                  {{ $t("wap.text99") }}:
                  <span class="c-regular-text">{{ $t("wap.text100") }}</span>
                </p>
                <p style="line-height: 1.2;" class="m-0 text-footer">
                  Email:
                  <span class="c-regular-text"> support@wghn.net.</span>
                </p>
                <p style="line-height: 1.2;" class=" m-0 text-footer">
                  Phone:
                  <span class="c-bold-text"> (+84)78 833 3633.</span>
                </p>
              </div>
            </div>
          </div>
          <div style="max-width: 400px;" class="mb-10 mr-10">
            <p class="c-bold-text m-0 title-footer">
              {{ $t("branchAddress") }}:
            </p>
            <div class="mt-5 ml-20">
              <p style="line-height: 1;" class="c-bold-text text-footer m-0">
                {{ $t("northern") }}:
              </p>
              <p class="c-bold-text m-0 text-footer">
                {{ $t("wap.text99") }}:
                <span style="max-width:350px" class="c-regular-text">{{
                  $t("wap.text100")
                }}</span>
              </p>
            </div>
            <div class="mt-5 ml-20">
              <p style="line-height: 1.5;" class="c-bold-text m-0 text-footer">
                {{ $t("wap.text101") }}:
              </p>
              <p style="line-height: 1.2;" class="c-bold-text m-0 text-footer">
                {{ $t("wap.text99") }}:
                <span style="max-width:350px" class="c-regular-text">
                  {{ $t("wap.text102") }}</span
                >
              </p>
            </div>
            <div class="mt-5 ml-20">
              <p style="line-height: 1.5;" class="c-bold-text m-0 text-footer">
                {{ $t("wap.text103") }}:
              </p>
              <p style="line-height: 1.2;" class="c-bold-text m-0 text-footer">
                {{ $t("wap.text99") }}:
                <span style="max-width:350px" class="c-regular-text">
                  {{ $t("wap.text104") }}</span
                >
              </p>
            </div>
          </div>
          <div>
            <p class="c-bold-text m-0 title-footer">
              {{ $t("policy") }}
            </p>
            <div class="mt-5 ml-20  cursor-pointer">
              <div>
                <p
                  v-for="(item, index) in listPolicy"
                  :key="index"
                  @click="handleRedirectPolicy(item.link)"
                  style="line-height: 1.2;"
                  class="m-0 mb-5 text-footer text-hover"
                >
                  {{ item.label }}
                </p>
              </div>
            </div>
          </div>
          <div>
            <p class="c-bold-text m-0 title-footer">
              {{ $t("account") }}
            </p>
            <div class="mt-5 ml-20 cursor-pointer">
              <div @click="handleAccountSetting">
                <p style="line-height: 1.2;" class="m-0 text-footer text-hover">
                  {{ $t("accountSettings") }}
                </p>
                <p
                  style="line-height: 1.2;"
                  class="m-0 mt-5 text-footer text-hover"
                >
                  {{ $t("accountInfo") }}
                </p>
              </div>
            </div>
          </div>
        </div>
        <div class="content-footer mt-10">
          <div class="mr-10 mb-10">
            <p class="c-bold-text title-footer m-0">{{ $t("wap.text133") }}:</p>
            <div class="flex mt-10 ml-20">
              <div class="mr-10" style="max-width:120px">
                <a href="https://apps.apple.com/vn/app/wghn/id1590376779">
                  <img
                    class="mb-10"
                    loading="lazy"
                    src="https://wghn.net/_next/static/media/app_store_img.778c7143.png"
                    alt="image app wghn store"
                /></a>
                <br />
                <a
                  href="https://play.google.com/store/apps/details?id=com.vhandicap.vphone"
                >
                  <img
                    loading="lazy"
                    src="https://wghn.net/_next/static/media/google_play_img.3f77cc6a.png"
                    alt="image app wghn gg play"
                /></a>
              </div>
              <div>
                <img
                  style="max-height: 124px; width:auto"
                  loading="lazy"
                  src="https://vnewstoday.com/upload-new/logo/qr-wghn-app.png"
                  alt="qr download app"
                />
              </div>
            </div>
          </div>
        </div>
        <div>
          <div style="margin-top: 30px;" class="text-center">
            <call-button />
          </div>
          <hr class="mt-10 mb-10" />
          <div class="text-center">
            <img style="height: 50px;" :src="images.memberOneIcon" alt="" />
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import footerUrl from "@/constant/footer";
import { getBackGround, getToken, getInfo } from "@/utils/wapAuth";
import LogoWBooking from "@/assets/img/svg/logo-wbooking.svg";
import memberOneIcon from "@/assets/img/iconV2/A member of-01.png";
import certificationIcon from "@/assets/img/iconV2/certification.svg";
import { SOURCE_BANK, LIST_POLICY } from "../../constant/contant";
import CallButton from "../../views/components/wapV2/button/call.vue";
export default {
  name: "app-footer",
  components: { CallButton },

  data() {
    return {
      SOURCE_BANK: SOURCE_BANK,
      bg: getBackGround(),
      year: new Date().getFullYear(),
      listPolicy: LIST_POLICY,
      images: {
        LogoWBooking,
        memberOneIcon,
        certificationIcon
      },
      listDataWG: [
        {
          url: "https://dl.wghn.net",
          lable: "WGHN App"
        },
        { url: "https://golfandcar.com/", lable: "Golf & Car" },
        { url: "https://checktee.com/wap", lable: "wBooking" },
        { url: "https://wghn.net", lable: "WGHN landingpage" },
        { url: "https://golfpose.com/", lable: "Golf Pose" },
        { url: "https://hio.wghn.net/wap", lable: "wHIO" },
        { url: "https://vnewstoday.com/", lable: "vNewsToday" },
        { url: "https://golferpost.com/", lable: "Golfer post" },
        { url: "https://shop.wghn.net", lable: "wShop" },
        { url: "https://vnewstv.com/", lable: "vNewsTV" },
        { url: "https://golfwithcoach.com/", lable: "Golf with coach" },
        { url: "https://handee.vn/", lable: "Handee" },
        { url: "https://thekingcup.com/", lable: "The King’s Cup" },
        { url: "https://ruleofgolf.com/", lable: "Rule of golf" },
        { url: "https://event.wghn.net/", lable: "Event golf" },
        { url: "https://event.wghn.net/", lable: "wTour" },
        { url: "https://inreviewgolf.com/", lable: "Inreview Golf" },
        { url: "https://vgolftravel.com/", lable: "wTravel" },
        { url: "https://gmagix.com/en", lable: "Gmagix" }
      ]
    };
  },
  props: {
    url: {
      default: () => footerUrl
    },
    appStore: {
      default: require("@/assets/img/homepage/app_store.png")
    },
    googlePlay: {
      default: require("@/assets/img/homepage/google_play.png")
    },
    footerBanner: {
      default: require("@/assets/img/logo/W_Booking_white.png")
    }
  },
  methods: {
    handleRedirectPolicy(url) {
      window.open(url, "_blank");
    },
    handleAccountSetting() {
      if (!getInfo()) {
        this.$store.dispatch("showLoginDialog");
        return;
      }
      this.$store.dispatch("setShowProfile", true);
    },
    getToken,
    handleRedirect(item) {
      if (!item.url) return;
      window.open(item.url, "_blank");
    },
    handleCall() {
      window.location.href = "tel:02471001088";
    }
  }
};
</script>

<style scoped>
.text-hover:hover {
  text-decoration: underline;
}
.text-footer {
  font-size: 14px;
}
.title-footer {
  font-size: 16px;
}
.content-footer {
  display: flex;
  justify-content: space-between;
}
.span-link-data-wg {
  font-size: 16px;
}
.btn-hotline {
  padding: 8px 15px;
  border-radius: 10px;
  background-color: #ff0000;
  color: #fff;
  font-size: 20px;
  font-weight: 700;
  font-size: 14px;
}
.footer {
  width: 100%;
}
.mb-12 {
  margin-bottom: 12px;
}
.pointer-cursor {
  cursor: pointer;
}
.align-right-sm-left {
  width: 100%;
  display: flex;
  align-items: flex-end;
  flex-direction: column;
}
.align-left {
  display: flex;
  align-items: flex-start;
  flex-direction: column;
}
.divider {
  height: 1px;
  width: 100%;
}
.mt-20 {
  margin-top: 20px !important;
}
.mt-20-xs {
  margin-top: 0px;
}
.show-sm {
  display: block;
}
.show-xs {
  display: none;
}
.platform-icon {
  display: flex;
  flex-direction: column;
  margin-bottom: 0px;
}
.desktop {
  display: block;
}
.mobile {
  display: none;
}
@media screen and (min-width: 0px) and (max-width: 769px) {
  .text-footer {
    font-size: 12px;
  }
  .title-footer {
    font-size: 12px;
  }
  .desktop {
    display: none;
  }
  .mobile {
    display: block;
  }
  .span-link-data-wg {
    font-size: 14px;
  }
  .align-right-sm-left {
    width: 100%;
    display: flex;
    align-items: flex-start;
    flex-direction: column;
  }
  .mt-20-xs {
    margin-top: 20px;
  }
  .show-sm {
    display: none;
  }
  .show-xs {
    display: block;
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
  }
  .mt-16-xs {
    margin-top: 16px;
  }
  .platform-icon {
    display: flex;
    flex-direction: row;
    margin-bottom: 40px;
  }
  .ml-16-xs {
    margin-left: 16px;
  }
  .span-link-data-wg {
    font-size: 14px;
  }
  .content-footer {
    display: block;
  }
}
</style>
